<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-form :inline="true" :model="listQuery" class="fn-clear">
          <el-form-item label="" class="fn-left">
            <Select key="4" :selected.sync="listQuery.shop_id" :data="selectList" clearable placeholder="请选择店铺" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-input v-model="listQuery.child_id" placeholder="请输入学员ID" />
          </el-form-item>
          <el-form-item class="fn-left">
            <el-date-picker v-model="listQuery.begin_time" value-format="yyyy-MM-dd" type="date" placeholder="开始日期" />
            <i class="split-time">至</i>
            <el-date-picker v-model="listQuery.end_time" value-format="yyyy-MM-dd" type="date" placeholder="结束日期" />
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="primary" @click="fnGetOrderList">查询</el-button>
          </el-form-item>
          <el-form-item label="" class="fn-left">
            <el-button type="warning" @click="openMealOrder">
              <el-tooltip class="item" effect="dark" content="打开的链接可供配餐公司访问" placement="top-start">
                <i class="el-icon-warning-outline" />
              </el-tooltip>
              全部订餐数据
            </el-button>
          </el-form-item>
        </el-form>

      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="店铺" prop="name" align="center" />
        <el-table-column label="时间" prop="sell_day" align="center" />
        <el-table-column label="学员ID" prop="child_id" align="center" />
        <el-table-column label="学员姓名" prop="sub_name" align="center" />
        <!-- <el-table-column label="家长手机" prop="phone" align="center" /> -->
        <el-table-column label="订餐信息" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.appoint_period_name + '-' + scope.row.recipe_title }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="是否领餐 " align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.use_status == 1 ? "是" : "否" }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="光盘奖励" align="center">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.clear_plate_info"
              style="width: 60px;height: 60px"
              :src="scope.row.clear_plate_info.image"
              :preview-src-list="[scope.row.clear_plate_info.image]"
              :fit="fit"
            />
            <p v-if="scope.row.clear_plate_info">拍摄人:{{ scope.row.clear_plate_info.editor_name }}</p>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer pagination-footer">
      <div class="block">
        <el-pagination
          layout="prev, pager, next, slot, jumper"
          :current-page.sync="listQuery.p"
          prev-text="上一页"
          next-text="下一页"
          :total="total"
          :page-size="listQuery.limit"
          @current-change="fnGetOrderList"
        >
          <div class="chax">
            {{ listQuery.p }}/{{
              total > 0 ? Math.ceil(total / listQuery.limit) : 1
            }}
          </div>
        </el-pagination>
        <div class="insert">
          <el-button type="primary">确定</el-button>
          <span class="pagination-count">
            符合查询结果:
            <i>{{ total }}条</i>
          </span>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
import Select from '@/components/Select'
var moment = require('moment')

export default {
  name: 'MenuOrderList',
  components: {
    Select

  },
  data() {
    return {
      selectList: [],
      url: '',
      lists: [],
      tableKey: 0,
      total: 0,
      listQuery: {
        p: 1,
        limit: 20,
        child_id: '',
        shop_id: '',
        begin_time: moment().format('YYYY-MM-DD'),
        end_time: moment().format('YYYY-MM-DD')
      }
    }
  },
  created() {
    this.fnGetSelectList()
    this.fnGetOrderList()
  },
  methods: {
    fnGetOrderList: function() {
      this.$http.orderFoodStatistics(this.listQuery).then(res => {
        this.tableKey++
        this.lists = res.data.list
        this.total = parseInt(res.data.count)
        this.url = res.data.url
      })
    },
    fnGetSelectList: function() {
      this.$http.getMyShopList().then(res => {
        this.selectList = res.data
      })
    },
    openMealOrder: function() {
      window.open(this.url)
    }
  }
}
</script>
<style lang="scss">
.food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;

    .el-form--inline .el-form-item {
      display: block;
    }

    .split-time {
      margin-right: 20px;
    }

    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }

    span.select-date {
      margin-right: 10px;
    }

    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
